export enum UserRole {
  ADMIN = 'ADMIN',
  CLIENTE = 'CLIENTE'
}